import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';

export class DojoPopup extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates(`DojoPopup`);
		Eventify(this.el, this);
		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);
	}
	connectedCallback() {

	}
	closePopup(evt) {
		evt.stopPropagation();
		this.remove();
	}
}
customElements.define(`dojo-popup`, DojoPopup);